import React from 'react';
import { IIconProps } from '../interfaces';

const StopAudioIcon: React.FC<IIconProps> = ({
                                                 color = '#ffffff',     // Default color for the play square
                                                 bgColor = '#3452FF',   // Default color for the background circle
                                                 width = '44'           // Default width and height of the icon
                                             }) => (
    <svg width={width} height={width} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_371_18034)">
            <circle cx="22" cy="22" r="13" fill={bgColor}/>
            <path fillRule="evenodd" clipRule="evenodd" d="M2 22C2 33.0457 10.9543 42 22 42C33.0457 42 42 33.0457 42 22C42 10.9543 33.0457 2 22 2C10.9543 2 2 10.9543 2 22Z" fill={bgColor}/>
            <mask id="mask0_371_18034" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="1" y="1" width="41" height="41">
                <path fillRule="evenodd" clipRule="evenodd" d="M2 22C2 33.0457 10.9543 42 22 42C33.0457 42 42 33.0457 42 22C42 10.9543 33.0457 2 22 2C10.9543 2 2 10.9543 2 22Z" fill={bgColor}/>
            </mask>
            <g mask="url(#mask0_371_18034)">
                {/* Square Path */}
                <rect x="15.625" y="15.625" width="12.75" height="12.75" fill={color}/>
            </g>
        </g>
        <defs>
            <filter id="filter0_d_371_18034" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="0.861604"/>
                <feGaussianBlur stdDeviation="0.861604"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_371_18034"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_371_18034" result="shape"/>
            </filter>
            <filter id="filter1_d_371_18034" x="17" y="12" width="13" height="18" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="0.871177"/>
                <feGaussianBlur stdDeviation="0.435588"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_371_18034"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_371_18034" result="shape"/>
            </filter>
        </defs>
    </svg>
);

export default StopAudioIcon;
